import styled from 'styled-components';

const Wrap = styled.span
  .withConfig({
    shouldForwardProp: (props) => {
      return !['active'].includes(props);
    },
  })
  .attrs((props) => {
    return {
      className: props.active ? 'active' : '',
    };
  })`
  position: relative;
  width: 36px;
  height: 18px;
  background-color: rgba(42, 48, 61, 0.5);
  border-radius: 9px;
  cursor: pointer;

  &:after {
    position: absolute;
    content: '';
    left: 2px;
    top: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #c3c3c3;
  }

  &.active {
    background: rgba(137, 85, 247, 0.5);

    &:after {
      right: 2px;
      left: auto;
      background-color: #fff;
    }
  }
`;

export default Wrap;
